import React from 'react'
import Multiselect from 'multiselect-react-dropdown'
import DatePicker from 'react-datepicker'
import styles from '../TicketingStyles/TicketingStyles.module.scss'
import { FilterTicketsDataType, assigneeDataType, ticketStatusDataType } from '../TicketingDataType'

const FilterTickets = ({
  assignee,
  status,
  getListOfTickets,
  selectedAssignee,
  setSelectedAssignee,
  selectedStatus,
  setSelectedStatus,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  setCurrentPage,
  setItemOffset,
  formatDateYYYYMMDD,
  setShowTicketingDetail,
}: FilterTicketsDataType) => {
  // const [selectedAssignee, setSelectedAssignee] = useState<assigneeDataType[]>()
  // const [selectedStatus, setSelectedStatus] = useState<ticketStatusDataType[]>()
  // const [startDate, setStartDate] = useState<Date | null>(null)
  // const [endDate, setEndDate] = useState<Date | null>(null)
  const onSelectAssignee = (selectedList: assigneeDataType[]) => {
    setSelectedAssignee(selectedList)
  }
  const onSelectStatus = (selectedList: ticketStatusDataType[]) => {
    setSelectedStatus(selectedList)
  }
  const onremoveAssignee = (selectedList: assigneeDataType[]) => {
    setSelectedAssignee(selectedList)
  }
  const onremoveStatus = (selectedList: ticketStatusDataType[]) => {
    setSelectedStatus(selectedList)
  }
  const resetFilters = () => {
    setShowTicketingDetail('')
    setStartDate(null)
    setEndDate(null)
    setSelectedAssignee([])
    setSelectedStatus([])
    setCurrentPage(1)
    setItemOffset(0)
    getListOfTickets(true, 0, [], [], '', '')
  }
  const applyFilters = () => {
    setCurrentPage(1)
    setItemOffset(0)
    getListOfTickets(true, 0)
  }

  return (
    <div className='row w-100'>
      <div className='col-12 col-lg-2 mb-2'>
        <DatePicker
          className={`form-control form-control-md form-control-solid p-2 border border-secondary rounded`}
          autoComplete='off'
          selected={startDate}
          dateFormat='yyyy/MM/dd'
          placeholderText='From date'
          selectsStart
          startDate={startDate}
          endDate={endDate}
          maxDate={endDate}
          onChange={(date: Date) => setStartDate(date)}
        /></div>
      <div className='col-12 col-lg-2 mb-2'>
        <DatePicker
          className={`form-control form-control-md form-control-solid p-2 border border-secondary rounded`}
          autoComplete='off'
          selected={endDate}
          dateFormat='yyyy/MM/dd'
          placeholderText='To date'
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          onChange={(date: Date) => setEndDate(date)}
        />
      </div>
      <div className='col-12 col-lg-2 mb-2'>
        <Multiselect
          className={`form-control-md form-control-solid p-0 ${styles.bg_primary}`}
          displayValue='ticket_status_name'
          placeholder='Select status'
          onKeyPressFn={function noRefCheck() { }}
          onRemove={onremoveStatus}
          onSearch={function noRefCheck() { }}
          selectedValues={selectedStatus}
          onSelect={onSelectStatus}
          options={status}
          showCheckbox
        />
      </div>
      <div className='col-12 col-lg-2 mb-2'>
        <Multiselect
          className={`form-control-md form-control-solid p-0 ${styles.bg_primary}`}
          displayValue='accouont_holder_name'
          placeholder='Select assignee'
          onKeyPressFn={function noRefCheck() { }}
          onRemove={onremoveAssignee}
          onSearch={function noRefCheck() { }}
          selectedValues={selectedAssignee}
          onSelect={onSelectAssignee}
          options={assignee}
          showCheckbox
        /></div>
      <div className='col-12 col-lg-2 mb-2'>
        <button onClick={applyFilters} className='btn btn-sm fw-bold btn-primary w-100'>
          Apply
        </button></div>
      <div className='col-12 col-lg-2 mb-2'>
        <button
          onClick={resetFilters}
          className='btn btn-sm btn-light fw-bold bg-color-white border border-muted shadow btn-active-light-primary w-100'
        >
          Reset
        </button>
      </div>
    </div>
  )
}

export default FilterTickets
